// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rMYC","questions":"styles_questions__1jT9S","footer":"styles_footer__1xgDB"};